module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_OpenLoop_00202.3f3e8f13.png";